import { cn } from "@babackapp/ui/lib/utils";
import { Column, Hr, Row } from "@react-email/components";
import type { SeparatorBlockProps } from "./types";
import useThemeContextualColors, { sectionToParent } from "../../hooks/use-theme-contextual-colors";
import { mapSeparatorSpacingToPixels } from "./index";


export function SeparatorEmailRenderer({ theme, section, block }: SeparatorBlockProps) {
  const colors = useThemeContextualColors(theme, sectionToParent(section));
  const margin = mapSeparatorSpacingToPixels(block.properties?.spacing);
  const isInvisible = block.properties?.invisible;

  return (
    <Row>
      <Column>
        <Hr className={cn("w-full")} style={{
          borderColor: colors.contrast,
          marginTop: margin,
          marginBottom: margin,
          opacity: isInvisible ? 0 : 1,
        }} />
      </Column>
    </Row>
  );
}
